import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { notification } from "antd";
import {
  ILogOutAllResponse,
  ILogOutAllVariables,
} from "../../../models/Interface/User.interface";
import axiosInstance, { CustomAxiosError } from "../../../utils/axios";
import { IErrorResponse } from "../../querys/querys.enum";
import { MutationKeys } from "../../mutation/mutation.enum";

const useLogOutAll = (
  options?: Partial<
    UseMutationOptions<
      ILogOutAllResponse,
      AxiosError<IErrorResponse>,
      ILogOutAllVariables
    >
  >
) => {
  return useMutation<
    ILogOutAllResponse,
    AxiosError<IErrorResponse>,
    ILogOutAllVariables
  >({
    mutationKey: [MutationKeys.LOG_OUT_ALL],
    mutationFn: async ({ userId }) => {
      try {
        const response = await axiosInstance.post<ILogOutAllResponse>(
          `/auth/log-out-all/${userId}`
        );
        return response.data;
      } catch (error) {
        console.error("Error in useLogOutAll mutationFn:", error);
        throw error;
      }
    },
    retry: 0,
    ...options,
    onSuccess: (data, variables, cx) => {
      try {
        notification.success({
          message: "Forced log out completed",
          description: `Revoked ${data.revokedTokens} sign-in token(s) across ${data.subAccounts} sub-account(s). Already-issued access tokens stay valid until they expire (up to 1 hour).`,
          placement: "top",
        });
        if (options?.onSuccess) {
          options.onSuccess(data, variables, cx);
        }
      } catch (successError) {
        console.error("Error in onSuccess handler:", successError);
      }
    },
    onError: (error: CustomAxiosError, variables, context) => {
      try {
        console.error("Log out all error:", error?.response?.data);
        notification.error({
          message: "Failed to log out all sub-accounts",
          description: error?.response?.data?.message || "Something went wrong",
          placement: "top",
        });
        if (options?.onError) {
          options.onError(
            error as AxiosError<IErrorResponse>,
            variables,
            context
          );
        }
      } catch (errorHandlingError) {
        console.error("Error in onError handler:", errorHandlingError);
      }
    },
  });
};

export default useLogOutAll;
